export default {
  header:
    'The Forum has evolved and grown over time to bring together more than 23,000 participants and 600 speakers across six annual conferences: the Conference of Montreal, the Toronto Global Forum, the World Strategic Forum, the Conference of Paris and the IEFA LatAm Forum, all hosted in association with Integra Capital, and the Phoenix Global Forum, which is hosted in association with Phoenix Sister Cities.',
  home: {
    toronto: {
      title: 'Fostering economic resilience',
      date: 'October 11 - 13 2023',
      content: `<p>The Toronto Global Forum (TGF) is organized by the International Economic Forum of the Americas (IEFA). The conference welcomes over 170 speakers and several thousand attendees annually from all over the world.</p>
        <p>Launched in 2006, the TGF brings together international thought leaders to foster dialogue and find solutions to national and global issues. In less than a decade, the Toronto Global Forum has emerged as one of North America’s key platforms for heads of state, central bank governors, ministers, entrepreneurs and global economic decision makers.</p>
        <p>The 17th edition of the Toronto Global Forum will be held at the Fairmont Royal York Hotel on October 11 - 13, 2023.</p>`,
      links: {
        learnMore: 'page:toronto',
        tickets: 'https://www.torontoglobalforum.com/#/tickets?affl=MAINWEBSITETGF2023BUYTICKET'
      }
    },
    miami: {
      title: 'Mastering the new economy',
      date: 'November 6 - 7 2023',
      content: `<p>The World Strategic Forum (WSF) is a global conference held annually in Miami, which is organized by the International Economic Forum of the Americas (IEFA). Launched in 2011, the WSF welcomes over 100 speakers and more than 3,000 attendees annually from all over the world.</p>
        <p>The central themes of the World Strategic Forum revolve around the Global Economy, Finance, Trade, Energy, and Infrastructure, with the central objective of addressing the opportunities and challenges at stake for the Americas in the global economic market.</p>
        <p>The 12th edition of the World Strategic Forum will be held at the Miami Biltmore Hotel on November 6-7, 2023.</p>`,
      links: {
        learnMore: 'page:miami',
        tickets:
          'https://www.worldstrategicforum.com/WORLDSTRATEGICFORUM2023-MIAMI-MASTERINGDISRUPTION#/tickets?lang=en'
      }
    },
    paris: {
      title: 'Conference of Paris',
      date: 'November 28 - 29 2023',
      content: `<p>The Conference of Paris (CDP) is a global conference organized by the International Economic Forum of the Americas (IEFA). The annual event acts as a platform to gather high level stakeholders in order to discuss Europe’s role in the global economy as we aim for a more inclusive, balanced and responsible society.</p>
        <p>The 7th edition of the Conference of Paris will be held in Paris at the OECD on November 28 - 29, 2023.</p>`,
      links: {
        learnMore: 'page:paris'
      }
    },
    buenosAires: {
      title: 'The IEFA LatAm Forum',
      date: 'March 26th - 27th 2024',
      content: `<p>The IEFA LatAm Forum is an annual global conference organized by the International Economic Forum of the Americas (IEFA) in collaboration with Integra Capital.</p>
        <p>The IEFA LatAm Forum was launched in 2022, with a special focus on the role that Latin America is increasingly playing in today’s global economy as the world seeks a more sustainable and resilient future.</p>
        <p>This year’s forum will be held in Buenos Aires at the Four Seasons Hotel from March 26th-27th, 2024.</p>`,
      links: {
        learnMore: 'page:buenos-aires'
      }
    },
    phoenix: {
      title: 'Forging the Future',
      date: 'May 2, 2024',
      content: `<p>The Phoenix Global Forum is hosted by the IEFA and Phoenix Sister Cities, and will launch in Spring 2024. As the fastest growing city in the US for the past five years, the region is quickly emerging as a hub for organizations within the biosciences, technology, sustainability and defense sectors. As a result, the outside investment being directed to Phoenix is helping to create a burgeoning ecosystem of business leaders, entrepreneurs, investors and academics.</p>
        <p>The Phoenix Global Forum will act as a platform where decision makers, thought leaders and experts in their respective fields convene to discuss society’s evolving needs amidst ongoing global challenges. The forum will examine solutions already in development, both in Phoenix and worldwide, while also fostering future innovation through connection and collaboration.</p>`,
      links: {
        learnMore: 'page:phoenix'
      }
    },
    montreal: {
      title: 'Conference of Montreal',
      date: 'June 10 - 12 2024',
      content: `<p>The Conference of Montreal (CDM) is an international conference organised by the International Economic Forum of the Americas (IEFA). It welcomes over 150 speakers and several thousand attendees from all over the world.</p>
        <p>Launched in 1994, the CDM brings together decision makers from all spheres of society to address the most pressing issues of our time. Over time, the Conference of Montreal has evolved to become an internationally recognized multi-day event attended by world leaders and decision makers from the worlds of government, business and academia, who convene to discuss topics ranging from the economy and global leadership to sustainability, energy and innovation. The event’s geographic location in the heart of French Canada offers audiences a rare sociopolitical economic insight which spans both a North American and European perspective, while also examining best practice worldwide.</p>
        <p>The 30th edition of the Conference of Montreal will be held in Montreal on June 10-12th 2024.</p>`,
      links: {
        learnMore: 'https://www.laconferencedemontreal.com/#/?affl=MAINWEBSITECDM2023&lang=en'
      }
    }
  },
  nextEvents: {
    index: [
      {
        title: 'Fostering economic resilience',
        conference: 'Toronto Global Forum',
        date: 'October 11-13, 2023',
        link: 'https://events.forum-americas.org/TORONTOGLOBALFORUM2023-FOSTERINGECONOMICRESILIENCE',
        image: '/images/events/toronto/toronto-17th-en.png'
      },
      {
        title: 'Mastering the new economy',
        conference: 'World Strategic Forum | Miami',
        date: 'November 6-7, 2023',
        link: 'https://events.forum-americas.org/WORLDSTRATEGICFORUM2023-MIAMI-MASTERINGDISRUPTION',
        image: '/images/events/miami/miami-12th-en.png'
      },
      {
        title: 'Bridging the divide',
        conference: 'Conference of Paris',
        date: 'November 28-29, 2023',
        link: 'https://events.forum-americas.org/LACONFERENCEDEPARIS2023',
        image: '/images/events/paris/paris-13th-en.png'
      },
      {
        title: '2th edition',
        conference: 'IEFA LatAm forum | Buenos Aires',
        date: 'March 2024',
        link: 'https://events.forum-americas.org/LATAMFORUM2023-BUENOSAIRES',
        image: '/images/events/buenosAires/thumbnail-buenosaires.jpg'
      },
      {
        title: '1st edition',
        conference: 'Phoenix Global Forum',
        date: 'May 2, 2024',
        link: 'https://www.phoenixglobalforum.com/',
        image: '/images/events/phoenix/thumbnail-phoenix.jpg'
      },
      {
        title: '30th edition',
        conference: 'Conference of Montreal',
        date: 'June 10-12, 2024',
        image: '/images/events/montreal/thumbnail-montreal.jpg'
      }
    ]
  },
  specialEvents: {
    title: 'Special Events'
  },
  pastEvents: {
    title: 'Past Events',
    index: [
      {
        title: 'Thriving in a world in transition',
        conference: 'The Conference of Montreal',
        date: 'June 12-14 2023',
        link: 'https://events.forum-americas.org/TheConferenceofMontreal2023-ThrivinginaWorldinTransition-Development',
        image: '/images/events/montreal/montreal-29th-en.png'
      },
      {
        title: 'Corporate citizenship for gender equality',
        conference: `IEFA & The Canadian Women's Foundation`,
        image: '/images/events/Corporate citizenship for gender equality.png',
        link: 'https://events.forum-americas.org/CorporateCitizenshipforGenderEquality',
        date: 'March 08, 2023'
      },
      {
        title: 'Tackling Growing Disruption',
        conference: 'Conference of Paris',
        image: '/images/events/paris/Tackling Growing Disruption.png',
        link: 'https://events.forum-americas.org/TheConferenceofParis2022-MasteringanewworldRedefiningdialogue',
        date: 'December 15–16, 2022'
      },
      {
        title: 'MasterClass ENGIE 2.0',
        conference: 'Conference of Paris',
        image: '/images/events/paris/master-class=2022.png',
        link: 'https://events.forum-americas.org/LaConfrencedeParis2022-MasterClassENGIE-20',
        date: 'December 15–16, 2022'
      },
      {
        title: 'Cooperation for a sustainable world',
        conference: 'IEFA LatAm Forum | Buenos Aires',
        image: '/images/events/buenosAires/thumbnail-buenosaires.jpg',
        link: 'https://events.forum-americas.org/LATAMFORUMofBuenosAires2022',
        date: 'November 14–15, 2022'
      },
      {
        title: 'Investing in trust',
        conference: 'World Strategic Forum | Miami',
        image: '/images/events/miami/Investing in trust.png',
        link: 'https://events.forum-americas.org/WORLDSTRATEGICFORUM2022-MIAMI',
        date: 'October 31 – November 01, 2022'
      },
      {
        title: 'Charting a new economy',
        conference: 'Toronto Global Forum',
        image: '/images/events/toronto/Charting a new economy.png',
        link: 'https://events.forum-americas.org/TorontoGlobalForum2022',
        date: 'October 17–19, 2022'
      }
    ]
  }
}
